import React, {createContext, useContext, useEffect, useState} from 'react';

const ProjectsContext = createContext(null);
const API_BASE = '/api';

export function ProjectsProvider({children}) {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/projects.php`, {credentials: 'include'})
            .then((res) => {
                if (!res.ok) throw new Error('Serverfehler beim Laden.');
                return res.json();
            })
            .then((data) => setProjects(Array.isArray(data) ? data : []))
            .catch(() => setLoadError('Projekte konnten nicht geladen werden.'))
            .finally(() => setLoading(false));
    }, []);

    const persist = async (nextProjects) => {
        const res = await fetch(`${API_BASE}/save.php`, {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({projects: nextProjects}),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) {
            throw new Error(data.error || 'Speichern fehlgeschlagen.');
        }
        setProjects(nextProjects);
    };

    const saveProject = (project) => {
        const next = projects.some((p) => p.id === project.id)
            ? projects.map((p) => (p.id === project.id ? project : p))
            : [...projects, project];
        return persist(next);
    };

    const deleteProject = (id) => persist(projects.filter((p) => p.id !== id));
    const saveAll = (nextProjects) => persist(nextProjects);
    const nextId = () => Math.max(0, ...projects.map((p) => p.id)) + 1;

    return (
        <ProjectsContext.Provider
            value={{projects, loading, loadError, saveProject, deleteProject, saveAll, nextId}}
        >
            {children}
        </ProjectsContext.Provider>
    );
}

export const useProjects = () => useContext(ProjectsContext);
